// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../../Api";
import ResponseChecker from "../../Middlewares/ResponseChecker";
import { defaultMessages } from "../../enums/responseMessages.js";

import Endpoints from "../../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## MobileApp.Events Get
/**
 *
 * @param {{params: object, query: { paymentMethodId: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.MobileApp.Events.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## MobileApp.Events Create
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.EventsRate: number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.MobileApp.Events.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Events Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.MobileApp.Events.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Events Update
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.EventsRate: number, isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (option, form) => {
  const response = await $api.put(
    Endpoints.MobileApp.Events.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Events Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.MobileApp.Events.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
